var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.meta.blockStudents && _vm.$store.getters['auth/isStudent'])?_c('educational-unavailable'):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }